import { ProductTileContainer } from "@faire/web-api--source/indigofair/data/ProductTileContainer";
import { ProductTileScreen } from "@faire/web-api--source/indigofair/data/ProductTileScreen";
import { ProductTileScreenContainer } from "@faire/web-api--source/indigofair/data/ProductTileScreenContainer";
import React from "react";
export var ProductTileClickImpressionContext = React.createContext({
    badgeEventTokens: new Set(),
    context: "".concat(ProductTileContainer.PRODUCT_TILE_CONTAINER_UNKNOWN, "|"),
    productTileContainer: ProductTileContainer.PRODUCT_TILE_CONTAINER_UNKNOWN,
    screenContext: ProductTileScreen.PRODUCT_TILE_SCREEN_UNKNOWN,
    containerContext: ProductTileScreenContainer.PRODUCT_TILE_SCREEN_CONTAINER_UNKNOWN,
    contextToken: ""
});
ProductTileClickImpressionContext.displayName = "ProductTileClickImpressionContext";
